import React from "react"
import SliderProductCard from "@/components/ProductCarousel/SliderProductCard"

const ProductCarouselLoader = props => {
  const products = props.productSkus ?? []

  return (
    <div className="product-carousel-wrapper" id="product-carousel-loader">
      <div className="product-carousel">
        {products?.map(product => {
          return (
            <div className="product-carousel__card" key={product.productSkuId}>
              <div className="product-card">
                <SliderProductCard />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ProductCarouselLoader
